import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, catchError, tap, of, take } from "rxjs";
import { Store } from "@ngrx/store";
import { LoadMedias, MediaModel, MediaState } from "../store";
import { MediaService } from "./media.service";
import { NotificationService } from "libs/tm-common/src/lib/services";

@Injectable()

export class MediaResolver {
	constructor(
		private store: Store<MediaState>,
		private notificationService: NotificationService,
		private mediaService: MediaService
	) {}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<MediaModel[]> {
		return this.mediaService.getMediaFiles(route.params.id).pipe(
			take(1),
			tap((mediaFiles: MediaModel[]) =>
				this.store.dispatch(new LoadMedias({ medias: mediaFiles }))
			),
			catchError(() => {
				this.notificationService.showErrorMessage("ResolveMediaFilesError", "", 5000);
				return of([]); //Open route, even if media files could not be loaded
			})
		);
	}
}
